import { useEffect, useState } from "react";
import { FieldData } from "rc-field-form/lib/interface";
import { ApolloError } from "@apollo/client";
import { ErrorCode } from "@ticketingplatform/api/dist/const/enums";
import { FormInstance, message } from "antd";
import { useIntl } from "react-intl";
import { VenueFormValues } from "views/Venues/VenueForm/types";

import {
  ErrorCodes,
  FieldError,
  FormMessageVariants,
  FormValues,
  UseFormErrorsReturnType,
} from "./types";

const useFormErrors = (form: FormInstance): UseFormErrorsReturnType => {
  const [apolloError, setApolloError] = useState<ApolloError | null>();
  const intl = useIntl();

  const onVenuesValuesChange = (values: VenueFormValues) => {
    const { input } = values;
    const { address } = input;
    const inputName = Object.keys(input)[0];
    const addressInputName = address && Object.keys(address)[0];
    const currentName: string[] = address
      ? ["input", inputName, addressInputName]
      : ["input", inputName];

    form.setFields([{ name: currentName, errors: [] }]);
  };

  const onFormValuesChange = (values: FormValues) => {
    const { input } = values;
    const inputName = Object.keys(input)[0];

    form.setFields([{ name: ["input", inputName], errors: [] }]);
  };

  const showErrorMessage = (
    errorCodes: ErrorCodes,
    name: string,
    messages: FormMessageVariants
  ) =>
    errorCodes?.map((err) => {
      if (err.code === ErrorCode.ENTITY_EXISTS) {
        return message.error(
          intl.formatMessage(messages.formEntityExistsError, { name })
        );
      }

      return message.error(
        intl.formatMessage(messages.formBasicError, {
          name,
        })
      );
    });

  useEffect(() => {
    const errors: FieldError[] =
      apolloError?.graphQLErrors.map((err) => ({
        message: err.message,
        path: err.errorInfo?.path || "",
        errorCode: err.errorType,
      })) || [];

    const errorFields: FieldData[] =
      errors?.map((field) => ({
        ...field,
        name: field.path.split("."),
        errors: [field.message],
        message: field.message,
      })) || [];

    form.setFields(errorFields);
  }, [apolloError, form]);

  return {
    setApolloError,
    onValuesChange: {
      onFormValuesChange,
      onVenuesValuesChange,
    },
    form,
    showErrorMessage,
  };
};

export default useFormErrors;
